import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { Icons } from '@/views/Automation/CampaignCreatorV2/helpers/icons';

interface Popover {
  content: string;
  delay?: { show?: number; hide?: number };
}

export interface CardVariableProps {
  name?: string;
  value?: string | number | object | Array<any>;
  groupName?: string;
  removable?: boolean;
  icon?: {
    type: Icons;
    fill?: boolean;
    height?: number;
  };
  popover?: Popover;
}

interface Emits {
  (e: 'remove'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcCardVariable.ts',
  props: {
    name: { default: 'Name' },
    value: { default: '' },
    groupName: null,
    removable: { type: Boolean, default: false },
    icon: null,
    popover: null
  },
  emits: ["remove"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'remove'): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emits, CcIcon }
}

})